import isMobile from "components/Stacker/utils/device-check"
import PropTypes from "prop-types"
import React, { useEffect, useRef } from "react"
import "./AmuletStackerNecklace.scss"

export default function AmuletStackerProductCode({
  productCode,
  imageUrl,
  onChainImageLoad,
  onProductResize = () => null,
}) {
  const ref = useRef()

  useEffect(() => {
    const getProductScale = () => {
      const divider = isMobile() ? 0.4 : 0.46
      const scale = divider / (1 / (ref.current.offsetWidth / 2183))
      onProductResize(scale)
    }

    window.addEventListener("resize", getProductScale)
    getProductScale()
    return () => {
      window.removeEventListener("resize", getProductScale)
    }
  }, [onProductResize])

  const src = productCode ? `${imageUrl}.png` : null
  return (
    <React.Fragment>
      {productCode ? (
        <img
          alt="Necklace"
          className="chain chain-img"
          id="chain-img"
          ref={ref}
          src={src}
          onLoad={onChainImageLoad}
        />
      ) : (
        <div>loading</div>
      )}
    </React.Fragment>
  )
}

AmuletStackerProductCode.propTypes = {
  productCode: PropTypes.object,
  imageUrl: PropTypes.string,
  onChainImageLoad: PropTypes.func,
  onProductResize: PropTypes.func,
}
